<template>
<div>
  <h4>Lista notowań</h4>
  <div class="row">
    <div class="col-md-3">
      <date-picker v-model="localId" @input="update"></date-picker>
    </div>
    <div class="col-md-9">
      <!--<input v-model="localSearch" @input="update" class="form-control" placeholder="szukaj..." autofocus>-->
    </div>
  </div>
  
  <br>
  
  <router-link class="btn btn-primary spaced" :to="{name: 'ProductAdd'}">Dodaj produkt</router-link>
  
  <div class="alert alert-info" v-if="showChangesAlert">
    <div class="row">
      <div class="col-sm-8">
        <strong>
          <info-icon></info-icon>
          Informacja
          <br>
        </strong>
        Wprowadzono zmiany w notowaniach
      </div>
      <div class="col-sm-4">
        <question-button
          class="btn btn-info pull-right"
          question="Czy na pewno opublikować zmiany cen?"
          @click="publish"
        >Opublikuj
        </question-button>
      </div>
    </div>
  </div>
  
  <div class="spaced">
    <question-button
      :question="notifyQuestion"
      class="pull-left btn btn-default"
      @click="sendNotifications"
    >
      Wyślij powiadomienia
    </question-button>
    
    <button
      class="pull-right btn btn-default"
      v-if="viewMode"
      @click="setEditMode"
    >
      Aktualizuj wszystkie
    </button>
    
    <button
      class="pull-right btn btn-default"
      v-if="editMode"
      @click="unsetEditMode"
    >
      Anuluj
    </button>
    
    <button
      class="pull-right btn btn-info"
      v-if="editMode"
      @click="usePreviousCard"
    >
      Użyj poprzednich notowań
    </button>

    <button
      class="pull-right btn btn-primary"
      v-if="editMode && showSaveEditModeButton"
      @click="saveEditModePrices"
    >
      <save-icon></save-icon>
      Zapisz
    </button>
    
    <button
      class="pull-right btn btn-default"
      v-if="editMode && showSaveEditModeButton"
      @click="setViewMode"
    >
      Anuluj
    </button>
  </div>
  
  <table class="table table-bordered table-hover table-striped">
    <thead>
    <tr>
      <th>Produkt</th>
      <th>Odmiana</th>
      <th>Pochodzenie</th>
      <th>Dostępność</th>
      <th>Jednostka</th>
      <th>Ceny</th>
      <th>Cena średnia</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="record in card.records">
      <td>{{ record.product.name }}</td>
      <td>{{ record.product.variety }}</td>
      <td>{{ record.product.origin }}</td>
      <td>{{ record.product.enabled }}</td>
      <td>{{ record.product.unit }}</td>
      <td>
        <div class="pull-left">
          <template v-for="price in record.publicPrices">
          {{ price.price|currency }} <br>
          </template>
        </div>
        <div class="pull-right" style="max-width: 100px;">
          <span class="draft-price" v-for="price in record.draftPrices">
            {{ price.price|currency }} <br>
          </span>
          
          <div v-for="(price, index) in record.editModePrices" v-if="editMode" class="input-group input-group-sm">
            <currency-input class="input-sm" v-model="price.price"></currency-input>
            <span class="input-group-btn">
              <button
                @click="removeEditModePrice(record, index)"
                class="btn btn-danger"
                type="button"
              >
                <minus-icon></minus-icon>
              </button>
            </span>
          </div>
          
          <button
            v-if="editMode"
            @click="addEditModePriceTo(record)"
            type="button"
            class="btn btn-info btn-sm"
            title="Dodaj nową cenę"
            style="width: 100%"
          >
            <plus-icon></plus-icon>
            dodaj cenę
          </button>
        </div>
      </td>
      <td>
        <div class="pull-left">
          {{ record.publicAvgPrice|currency }}
        </div>
        <div class="pull-right">
          <span class="draft-price" v-if="record.draftPrices.length > 0">
            {{ record.draftAvgPrice|currency }}
          </span>
        </div>
      </td>
      <td>
        <router-link :to="{ name: 'RecordEdit', params: { id: record.id } }">edytuj</router-link>
      </td>
    </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import moment from 'moment'
import Api from './../api'
import InfoIcon from './InfoIcon.vue'
import QuestionButton from './QuestionButton.vue'
import flash from './../Flash'
import CurrencyInput from './CurrencyInput.vue'
import PlusIcon from './PlusIcon.vue'
import SaveIcon from './SaveIcon.vue'
import MinusIcon from './MinusIcon.vue'
import DatePicker from './DatePicker.vue'
import Flash from '../Flash'

export default {
  props: {
    id: {type: String, default: moment().format('YYYY-MM-DD')},
    search: {type: String, default: ''}
  },
  components: {
    InfoIcon,
    QuestionButton,
    CurrencyInput,
    PlusIcon,
    SaveIcon,
    MinusIcon,
    DatePicker
  },
  data () {
    return {
      mode: 'view',
      localId: this.id,
      localSearch: this.search,
      card: {
        notifyLogs: []
      },
      notifying: false
    }
  },
  methods: {
    usePreviousCard () {
      Api.card.usePrevious(this.id).then(this.usePreviousSuccess, this.usePreviousError)
    },
    usePreviousSuccess ({body}) {
      body.records.forEach(r => {
        r.editModePrices = []
        r.publicPrices.forEach(p => {
          r.editModePrices.push({...p})
        })
      })
      this.card = body
    },
    usePreviousError () {},
    sendNotifications () {
      this.notifying = true
      Api.card.notify(this.id).then(this.onNotifySuccess, this.onNotifyError).then(() => { this.notifying = false })
    },
    onNotifySuccess ({body}) {
      this.setCard(body)
      Flash.success('Powiadommienia zostały wysłane poprawnie')
    },
    onNotifyError ({status}) {
      if (status === 422) {
        Flash.error('Nie wszystkie ceny zostały opublikowane.')
      } else {
        Flash.error('Wystąpił nieoczekiwany błąd podczas wysłania powiadomień - skontaktuj się z administratorem')
      }
    },
    setViewMode () {
      this.mode = 'view'
    },
    saveEditModePrices () {
      this.card.records.map(r => {
        if (r.editModePrices.length > 0) {
          r.draftPrices = []
          r.editModePrices.forEach(p => {
            if ((r.editModePrices.length === 1 && p.price === '0.00') || p.price > 0) {
              delete p.id
              r.draftPrices.push({...p})
            }
          })
          r.editModePrices = []
        }
      })
      Api.card.put(this.id, this.card).then(({body}) => { this.setCard(body) })
      this.setViewMode()
    },
    addEditModePriceTo (record) {
      record.editModePrices.push({
        price: '0.00'
      })
    },
    removeEditModePrice (record, index) {
      record.editModePrices.splice(index, 1)
    },
    setEditMode () {
      this.mode = 'edit'
    },
    unsetEditMode () {
      this.mode = 'view'
    },
    goToEdit (record) {
      this.$router.push({
        name: 'RecordEdit',
        params: {
          id: record.id
        }
      })
    },
    publish () {
      Api.card.publish(this.id).then(this.publishSuccess, this.publishError)
    },
    publishSuccess ({body}) {
      this.setCard(body)
      flash.success('Opublikowano zmiany w notowaniach poprawnie')
    },
    publishError () {
      flash.error('Wystąpił błąd podczas publikowania zmian w notowaniach, skontaktuj się z administratorem')
    },
    update () {
      this.$router.push({
        name: 'Records',
        params: {
          id: this.localId,
          search: this.localSearch || undefined
        }
      })
    },
    fetchData () {
      Api.card.get(this.id, this.fetchSuccess)
    },
    setCard (body) {
      body.records.forEach(r => {
        r.editModePrices = []
      })
      this.card = body
    },
    fetchSuccess ({body}) {
      this.setCard(body)
    }
  },
  computed: {
    notifyQuestion () {
      const txt = 'Czy na pewno wysłać powiadomienia do klientów o nowych cenach?'
      const dates = this.card.notifyLogs.join(', ')
      if (dates) {
        return `UWAGA! Powiadomienia były wysłane już o: ${dates}. ${txt}`
      }
      return txt
    },
    getRecordsWithEditModePrices () {
      return this.card.records.filter(r => r.editModePrices.length > 0)
    },
    showSaveEditModeButton () {
      return this.getRecordsWithEditModePrices.length > 0
    },
    showChangesAlert () {
      return this.card.records && this.card.records.filter(r => r.draftPrices.length > 0).length > 0
    },
    viewMode () {
      return this.mode === 'view'
    },
    editMode () {
      return this.mode === 'edit'
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData',
    date (val) {
      this.localId = val
    },
    search (val) {
      this.localSearch = val
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// Records.vue?155799d4